import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'


// import 'core-js/stable'
// import 'regenerator-runtime/runtime'



/* 路由 */
import router from './router'

// import swiper from "swiper";

// Vue.prototype.$swiper = swiper;

/* axios */
// import axios from './api'
// import api from './api/api'
// Vue.prototype.http = axios;
// Vue.prototype.api = api;

import './utils/http';
import post from './utils/post'
Vue.prototype.$post = post

/* swiper */
import 'swiper/css/swiper.css';


/* 重置样式 */
import './assets/css/reset.min.css'

/* 全局样式 */
import './assets/css/global.css'

/* 字体样式 */
import './assets/css/font.css'


/* element-ui */
import './plugins/elemenet/index.js'



/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'



import LsHeader from './components/LsHeader'
Vue.component(LsHeader.name, LsHeader)

import LsFooter from './components/LsFooter'
Vue.component(LsFooter.name, LsFooter)

import LsLayout from './components/LsLayout'
Vue.component(LsLayout.name, LsLayout)

import LsPanel from './components/LsPanel'
Vue.component(LsPanel.name, LsPanel)

import LsTable from './components/LsTable'
Vue.component(LsTable.name, LsTable)

import LsUpload from './components/LsUpload'
Vue.component(LsUpload.name, LsUpload)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js